import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  max-height: 100%;

  overflow: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};

  padding: ${({ theme }) =>
    `${theme.spacing(6)} ${theme.spacing(5)} ${theme.spacing(3)}`};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};

  padding: ${({ theme }) => `0 ${theme.spacing(5)} ${theme.spacing(6)}`};

  overflow: auto;
`;

export const Section = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SectionItem = styled.div<{ $isDate?: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.subtitle1)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  ${({ $isDate }) =>
    $isDate &&
    css`
      width: 13.2rem;
    `};
`;

export const Affix = styled.span`
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(3)};

  border-top: 1px solid ${({ theme }) => theme.palette.grey[100]};
`;

export const Interactions = styled.div`
  flex: 1;
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;
`;
